<script lang="ts" setup>

</script>

<template>
  <svg class="size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"
       xmlns="http://www.w3.org/2000/svg">
    <path d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" stroke-linecap="round"
          stroke-linejoin="round"/>
  </svg>

</template>

<style scoped>

</style>